export default __webpack_public_path__ + "static/media/login-ban-repo.bda17e22.png";